export enum DetailsFieldName {
    Names = 'names',
    ShortNames = 'shortNames',
    Descriptions = 'descriptions',
    Ordering = 'ordering',
    RateGroupKey = 'externalIdentifier',
}

export enum SettlementConfigurationsFieldName {
    MaximumTime = 'maximumTime',
    Extent = 'extent',
    Options = 'options',
    CurrencyCode = 'currencyCode',
    DepositTaxRateMode = 'depositTaxRateMode',
    RequirePaymentCardDuringOnlineCheckIn = 'requirePaymentCardDuringOnlineCheckIn',
}

export enum FieldSectionName {
    Dates = 'dates',
    Rates = 'rates',
}

export enum PolicyExceptionsDatesFieldName {
    FirstTimeUnitStartUtc = 'firstTimeUnitStartUtc',
    LastTimeUnitStartUtc = 'lastTimeUnitStartUtc',
    TimeUnitIntervals = 'timeUnitIntervals',
}

export enum PaymentPolicyFieldName {
    ExceptionType = 'exceptionType',
    Rates = 'rates',
    SettlementRules = 'settlementRules',
    CancellationFees = 'cancellationFees',
    RequirePaymentCardDuringOnlineCheckIn = 'requirePaymentCardDuringOnlineCheckIn',
}
